import { __rest } from '../../node_modules/tslib/tslib.es6.js';
import { MinusIcon, PlusIcon } from '@koaly/koaly-ui-icons';
import React, { useState } from 'react';
import styled from 'styled-components';
import { Card } from '../Card/Card.js';
import { SvgButton } from '../SvgButton/SvgButton.js';

const StyledCollapsibleCard = styled(Card) `
  h1, h2, h3, h4, h5 {
    cursor: pointer;
  }
`;
const HideShow = styled.span `
  ${({ isOpen }) => !isOpen && `
    display: none;
  `};
`;
const CollapsibleCard = (_a) => {
    var { children, defaultOpen, ariaLabelCloseButton, ariaLabelOpenButton } = _a, cardProps = __rest(_a, ["children", "defaultOpen", "ariaLabelCloseButton", "ariaLabelOpenButton"]);
    const [isOpen, setIsOpen] = useState(false);
    const toggleLink = (React.createElement(SvgButton, { "aria-label": isOpen ? ariaLabelCloseButton : ariaLabelOpenButton, onClick: () => setIsOpen(!isOpen) }, isOpen ? React.createElement(MinusIcon, { width: "24", height: "24" }) : React.createElement(PlusIcon, { width: "24", height: "24" })));
    return (React.createElement(StyledCollapsibleCard, Object.assign({ right: toggleLink, titleSpaceAfter: !isOpen ? 0 : undefined, titleOnClick: () => setIsOpen(!isOpen) }, cardProps),
        React.createElement(HideShow, { isOpen: isOpen }, children)));
};

export { CollapsibleCard };
//# sourceMappingURL=CollapsibleCard.js.map
